import React from 'react'
import Pane from 'components/Common/Pane'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import { useParams } from 'react-router'
import { useDestinationPage } from 'marketing/api'
import styled from 'styled-components'
import SearchHero from './SearchHero'
import { rem } from 'polished'
import HeroOfferCarouselSection from 'home/components/OfferCarousels/HeroOfferCarouselSection'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Components from './Components'
import HttpStatus from 'components/Common/HttpStatus'
import Error404Page from 'components/Pages/Error404Page'

const DestinationLandingPageContainer = styled(Pane)`
  padding-bottom: ${rem(40)};
`

const StyledHeroOfferCarousel = styled(HeroOfferCarouselSection)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};

 ${mediaQueryUp.desktop} {
   padding-top: ${rem(80)};
 }
`

function DiscoverDestinationPage() {
  const { destination } = useParams<{destination: string}>()
  const { data: destinationPageData, isLoading } = useDestinationPage(destination)

  if (isLoading) {
    return <LoadingIndicator />
  }
  if (!destinationPageData) {
    return <HttpStatus code={404}>
      <Error404Page />
    </HttpStatus>
  }

  return (
    <DestinationLandingPageContainer>
      <SearchHero {...destinationPageData}/>
      <StyledHeroOfferCarousel />
      {destinationPageData?.components.map((component, index) => <div
      key={`${index}-${component.title}`} data-type={component.contentTypeId}>
        <Components {...component} />
      </div>)}
    </DestinationLandingPageContainer>
  )
}

export default DiscoverDestinationPage
